export default __webpack_public_path__ + "static/split-tunneling-81aa8d56b7922585dcbeb7c184ef41b4.png";